import classnames from "classnames";
import { ReactElement, SyntheticEvent } from "react";

import Img from "@components/FileServer/Img";

interface Props {
  customCheckboxClass?: string;
  customContainerClass?: string;
  customLabelClass?: string;
  onClick?: (e?: SyntheticEvent) => void;
  swapOrder?: boolean;
  checked?: boolean;
  id?: string;
  idCheckbox?: string;
  idLabel?: string;
  label?: string | ReactElement;
  disabled?: boolean;
}

const Checkbox = (props: Props) => {
  const handleClick = (event: SyntheticEvent) => {
    if (props.disabled) {
      return;
    }

    props.onClick?.(event);
  };

  const handleKeyDown = (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();
    handleClick(event);
  };

  return (
    <div
      role="checkbox"
      className={classnames("checkbox", props.customContainerClass, {
        disabled: !!props?.disabled,
      })}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={props.disabled ? -1 : 0}
      id={props.id}
      aria-checked={!!props.checked}
      aria-disabled={props.disabled || undefined}
    >
      {props.checked ? (
        <Img
          src="/static/images/ico-checkbox-checked.svg"
          className={classnames(
            "checkbox-background pointer",
            props.customCheckboxClass
          )}
          id={props.idCheckbox}
          alt=""
          role="presentation"
        />
      ) : (
        <Img
          src="/static/images/ico-checkbox-unchecked.svg"
          className={classnames(
            "checkbox-background pointer",
            props.customCheckboxClass
          )}
          id={props.idCheckbox}
          alt=""
          role="presentation"
        />
      )}
      <span
        className={classnames(
          "checkbox-label",
          {
            "checkbox-swap-order": props.swapOrder,
          },
          props.customLabelClass
        )}
        id={props.idLabel}
      >
        {props.label}
      </span>
    </div>
  );
};

export default Checkbox;
